import * as TK from 'components/PDP/Details/components/ProductCode/translations/product-code.locale.constants';

export const productCodeCommonLocale = {
  [TK.PRODUCT_CODE]: 'Product Code',
};
